import { useContext } from "react";

import { AppContext } from "../../App.context";
import { LinkButton } from "../Button";
import { ShowPointsWrapper } from "./ShowPoints.style";

export const ShowPoints = () => {
  const { points, questionsCount } = useContext(AppContext);

  return (
    <ShowPointsWrapper>
      <p>Uzyskano wynik</p>
      <h5>
        {points} / {questionsCount}
      </h5>
      <LinkButton href={window.location}>Spróbuj ponownie</LinkButton>
    </ShowPointsWrapper>
  );
};
